import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import { createStore } from "./store/store";

import InstantSearch from 'vue-instantsearch'
import PortalVue from 'portal-vue'
import VeeValidate from 'vee-validate'

import './bootstrap/font-awesome.js'
import './bootstrap/filters.js'
import './bootstrap/components.js'
import './bootstrap/vee-validate.js'
import './bootstrap/dayjs.js'
import './bootstrap/toasted.js'


import "./main.scss";

Vue.config.productionTip = false;

Vue.use(InstantSearch);
Vue.use(VeeValidate);

export default new Vue({
    router,
    store: createStore(),
    render: h => h(App)
}).$mount('#app');
